import { useEffect, useState } from "react";
var useDeviceDetect = function () {
    var _a = useState(false), isMobile = _a[0], setIsMobile = _a[1];
    var _b = useState(false), isIPhone = _b[0], setIsIPhone = _b[1];
    var _c = useState(false), isNotChrome = _c[0], setIsNotChrome = _c[1];
    var _d = useState(false), isAndroid = _d[0], setIsAndroid = _d[1];
    var _e = useState(null), isTraceData = _e[0], setIsTraceData = _e[1];
    var collectTraceData = function () {
        return {
            urlActual: window.location.href,
            agenteUsuario: navigator.userAgent,
            idioma: navigator.language,
            resolucionPantalla: "".concat(window.screen.width, "x").concat(window.screen.height),
            resolucionVentana: "".concat(window.innerWidth, "x").concat(window.innerHeight),
            plataforma: navigator.platform,
            online: navigator.onLine,
            cookiesHabilitadas: navigator.cookieEnabled,
            fechaHora: new Date().toISOString(),
        };
    };
    useEffect(function () {
        var userAgent = typeof window.navigator === "undefined" ? "" : navigator.userAgent;
        var mobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
        var iPhone = Boolean(userAgent.match(/iPhone|iPad|iPod/i));
        var notChrome = !userAgent.match(/Chrome|CriOS/i);
        var notAndroid = userAgent.match(/Android/i);
        var traceData = collectTraceData();
        setIsMobile(mobile);
        setIsIPhone(iPhone);
        setIsNotChrome(notChrome);
        setIsAndroid(notAndroid);
        setIsTraceData(traceData);
    }, []);
    return { isMobile: isMobile, isIPhone: isIPhone, isNotChrome: isNotChrome, isAndroid: isAndroid, isTraceData: isTraceData };
};
export default useDeviceDetect;
